import React, { useEffect, useState, forwardRef, useImperativeHandle, Ref } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { userdetailsForUpdate, roledetailsForUpdate, userEditCheckBoxes, updateRoleDetails } from "../../../constants";
import FormFields from "../../Forms/FormFields";
import { toast } from 'react-toastify';
import BadgesComponent from "../../../components/common/Badges";
// import {CustomSpinner} from "../../../components/common/CustomSpinner"
import Loading from "@components/common/Loading";
import CheckboxComponent from "../../../components/common/CheckBox";
import DataTable from "../../../components/common/CommonDataTable";
import './userManagementUpdate.css'
import Button from '../../../components/common/Button';
import { Checkbox } from 'antd';
import RedInfoIcon from '../../../assets/svg/exclamation.svg'
import ButtonModal from '@components/common/Button';
import endpoints from '../../../config/endpoints';
import { getData, getDataWithCache, postDataJSON } from '../../../services/CommonApiService';
import CommonFormFields from '../../Forms/CommonFormFields';
import { useTranslation } from 'react-i18next';
import { resetForm, updateForm } from '../../../store/actions/userManagementAction';
//import axios from 'utils/axiosExt';
import { RootState } from '../../../store/reducers';
import { useDispatch,useSelector } from 'react-redux';
import Auth from '../../../utils/auth'
import axios from '../../../utils/axiosExt';
import dayjs from 'dayjs';
import { errorLogger, infoLogger } from '@utils/applicationLogUtils';
import isUsingGramPanchayatUtils from '@utils/isUsingGrampanchayatUtil';
import { decodeWithKeyAndShift, encodeWithKeyAndShift } from '@utils/base64Utils';
import AlertPopup from '../../UserManagement/CreateNewUser/AlertModal/index';
import CommonModal from '../../UserManagement/CreateNewUser/AlertModal/index';
import MobileNumberOTPVerification from './MobileNumberOTPVerification';
interface objectTypes {
  isError: boolean,
  message: string,
  isDisable: boolean,
  value: any,
  id?: any,
  verifiedDetails?: any
  code?: any,
  compositeId?:any
}

interface objectType {
  user: any;
  flow: string;
  handleChange: (e: any, key: string) => void;
}

interface formStateType {
  [key: string]: objectTypes
}

interface formDataType {
  [key: string]: any;
}
export interface ChildComponentHandlerUpdateUser {
  handleUpdateSave: () => void;
}
const UserManagementUpdate = forwardRef((props: objectType, ref: Ref<ChildComponentHandlerUpdateUser>) => {
  const { user, flow, handleChange } = props;
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch=useDispatch();
  const ishprEntered=useSelector((state:RootState)=>state.user.ishprEntered);
  const hprNullCheck=useSelector((state:RootState)=>state.user.hprNullCheck);
  const hprNumberCheck=useSelector((state:RootState)=>state.user.hprNumberCheck);
  const userStatus =  useSelector((state: RootState) => state.user.userStatusUpdate);
  const isNotVerified=useSelector((state:RootState)=>state.user.isNotVerified);
  const isOkButtonClicked=useSelector((state:RootState)=>state.user.isOkButtonClicked);
  const consentDetails = useSelector((state:RootState)=>state.user.consentDetails)
  const verificationProcessId = useSelector((state:RootState)=>state.user.verificationProcessId)
  
  useImperativeHandle(ref, () => ({

    handleUpdateSave() {
     // navigate('/user-management');
        onHandleSave();
      }
    }));
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [alertModalOpen, setAlertModalOpen] = useState<boolean>(false);
  const [userFormState, setuserFormState] = useState<formStateType>({
    fName: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    lName: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    user_type: {
      isError: false,
      message: '',
      id: '',
      code: undefined,
      isDisable: false,
      value: '',
    },
    designation: {
      isError: false,
      message: '',
      id: '',
      code: undefined,
      isDisable: false,
      value: '',

    },
    mob: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    a_mob: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    email: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    doj: {
      isError: false,
      message: '',
      isDisable: false,
      value: null,
    },
    hpr_id:{
      isError: false,
      message: '',
      isDisable: true,
      value: '',
    },
    abha_id:{
      isError: false,
      message: '',
      isDisable: true,
      value: '',
    },
    hpr_abha_id: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
    },
    user_status: {
      isError: false,
      message: '',
      isDisable: false,
      value: 'true',
    },
   
    effective_from_date: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
    },

  });
  const [roleFormState, setRoleFormState] = useState<formStateType>({
    role_name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined,
      compositeId:[]
    },
    state: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    zone_division: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    district: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    sub_district: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    sub_division: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    health_block: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    rural_urban: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    block: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    village: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    gram_panchayat: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    ulb: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    ward: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },


  });


  const [checkBoxes, setCheckBoxes] = useState<formStateType>({
    reportUserWithLineListingData: {
      isError: false,
      message: '',
      isDisable: false,
      value: false,
    },
    offlineModeAccess: {
      isError: false,
      message: '',
      isDisable: false,
      value: false,
    },
    mfa: {
      isError: false,
      message: '',
      isDisable: false,
      value: false,
    },
    volunteerForPmsma: {
      isError: false,
      message: '',
      isDisable: false,
      value: false,
    }
  })
  const [formStateForFacility, setFormStateForFacility] = useState<formStateType>({
    hpr_id: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    health_facility_type: {
      isError: false,
      message: '',
      isDisable: false,
      value: 'NA',
      id:'',
      code:undefined
    },
    health_fName: {
      isError: false,
      message: '',
      isDisable: false,
      value: 'NA',
      id:'',
      code:undefined
    },
    mobiliser_tagged: {
      isError: false,
      message: '',
      isDisable: false,
      value: 'NA',
    },
    health_provider_tagged: {
      isError: false,
      message: '',
      isDisable: false,
      value: 'NA',
      id:'',
      code:undefined
    },
    volunteerForPmsma: {
      isError: false,
      message: '',
      isDisable: false,
      value: false,
    },
  });

  const usereditcheckBoxes =  user.usertype_name === "Facility Level User" ? {...userEditCheckBoxes} : {
    reportUserWithLineListingData: userEditCheckBoxes.reportUserWithLineListingData,
    offlineModeAccess: userEditCheckBoxes.offlineModeAccess,
    mfa: userEditCheckBoxes.mfa
  }

  const [userFormData, setUserFormData] = useState<any>(userdetailsForUpdate);
  const [roleFormData, setRoleFormData] = useState<any>(updateRoleDetails);
  const [checkBoxesFormData, setCheckBoxesFormData] = useState<any>(usereditcheckBoxes);
  const [isVerified,setIsVerified]=useState<boolean>(false);
  const [statusActive,setStatusActive]=useState<string>("");
  const [isHprAbhaVerified,setIsHprAbhaVerified]=useState<boolean>(false);
  const [isStatusActive,setIsStatusActive]=useState<boolean>(false);
  const [statusValue,setStatusValue]=useState<boolean>(false);
  const [MFAValue,setMFAValue]=useState<boolean>(false);
  const clearHpr=useSelector((state:RootState)=>state.user.clearHpr);
  const [previousRoles, setPreviousRoles] = useState<any>([]);
  const [facilityDetails,setFacilityDetails]=useState<any>([]);
  const [isFacilityOrFieldUser, setIsFacilityOrFieldUser] = useState<string>('');
  const [previousCompositeRoles, setPreviousCompositeRoles] = useState<any>([]);
  const [currentRoles, setCurrentRoles] = useState<any>([]);
  const [currentCompositeRoles, setCurrentCompositeRoles] = useState<any>([]);
  const [effectiveDate, setEffectiveDate] = useState<any>();
  const [updateFormData, setUpdateFormData] = useState<any>({
    userDetails: {
      original:{
        fName:'',
        lName:'',
        email:'',
        mob:'',
        a_mob:'',
        hpr_id:'',
        user_status:'',
        reportUserWithLineListingData:'',
        volunteerForPmsma:'',
        offlineModeAccess:'',
        mfa:'',
      },
      updated:{
        fName:'',
        lName:'',
        email:'',
        mob:'',
        a_mob:'',
        hpr_id:'',
        user_status:'',
        reportUserWithLineListingData:'',
        volunteerForPmsma:'',
        offlineModeAccess:'',
        mfa:'',
      },
    },
    roleLocationDetails: {
      original:{
        role_name:[],
      },
      updated:{
        role_name:[],
      },
    },
  });
  const [oldMobileNumber, setOldMobileNumber] = useState<string>('');
  const [oldEmail, setOldEmail] = useState<string>('');
  const [showEditMobileNumberModal, setShowEditMobileNumberModal] = useState(false);


  

  const setIsFieldDisabled = (roleDetails: any, properties: { [key: string]: any }, ...keys: string[]) => {
    return keys.reduce((acc, key) => {
      acc[key] = { ...roleDetails[key], ...properties };
      return acc;
    }, { ...roleDetails });
  };
  

  const handleUserFormState = (value: any | boolean, key: string, option?: any, id?: any, code?: any) => {
    
    if(key==='fName'){
      dispatch(updateForm("fName",value));
    }
    if(key==='lName'){
      dispatch(updateForm("lName",value));
    }
    if(key==='hpr_id'){
      dispatch(updateForm("hfrAbha",value));
    }
    if(key==='user_status'){
      dispatch(updateForm("userStatusUpdate", value))
    }
    setuserFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        isError: false,
        message: '',
        id: id,
        code: code
      },
    }));
    setUpdateFormData({
      ...updateFormData,
      userDetails:{
        ...updateFormData.userDetails,
        updated:{
          ...updateFormData.userDetails.updated,
          [key]:value
        }
      }
    });
  }
  const handleRoleFormState = (value: string | boolean, key: string, option?: any, id?: any, code?: any,compositeId?:any) => {
    setRoleFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        isError: false,
        message: '',
        id: id,
        code: code,
        compositeId:compositeId,
      },
    }));
    setUpdateFormData({
      ...updateFormData,
      roleLocationDetails:{
        ...updateFormData.roleLocationDetails,
        updated:{
          ...updateFormData.roleLocationDetails.updated,
          [key]:value
        }
      }
    });
    if(key==="role_name"){
    setCurrentRoles(id);
    setCurrentCompositeRoles(compositeId);
    }
  }
  const handleCheckBoxes = (value: string | boolean, key: string, id: any) => {
    setCheckBoxes((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id
      },
    }));
    setUpdateFormData({
      ...updateFormData,
      userDetails:{
        ...updateFormData.userDetails,
        updated:{
          ...updateFormData.userDetails.updated,
          [key]:value
        }
      }
    });
  };
  const isVerify=useSelector((state:RootState)=>state.user.isVerified);
  //setIsHprAbhaVerified(isVerify==='true');
  const constructActionData = (dataList: any) => {
    return dataList.map((data: any) => {
      return {
        ...data,
        facility_name: data.facility_name !== null ? data.facility_name : '-----',
        facility_type_name:data.facility_type_name!==null?data.facility_type_name:'-----',
        hfr_id:data.hfr_id!==null?data.hfr_id:'-----',
        health_provider_name:data?.healthprovider_details!==null?data?.healthprovider_details?.map((hp:any) => hp?.healthprovider_name)?.join(', '):'-----',
        mobiliser_name:data?.mobiliser_details!==null?data?.mobiliser_details?.map((mb:any) => mb?.mobiliser_name)?.join(', '):'-----',
        effective_from_dt:data.effective_from_dt!==null?data.effective_from_dt:'-----',
        effective_to_dt:data.effective_to_dt!==null?data.effective_to_dt:'-----',
      };
    });
  };
  const fetchLinkedFacilitiesInfo=async () =>{
    const facilityData=await getData<any[]>(`${endpoints.getActiveLinkedFacilitiesByUserId(id)}`);
    facilityData.data[0].forEach((item : any) => {
      item.effective_from_dt = item.effective_from_dt && dayjs(item.effective_from_dt).format('DD-MM-YYYY');
      item.effective_to_dt = item.effective_to_dt && dayjs(item.effective_to_dt).format('DD-MM-YYYY');
    });
    let filteredOverviewArr = [];
    filteredOverviewArr.push(constructActionData(facilityData.data[0]));
    filteredOverviewArr = filteredOverviewArr[0].filter((element: any) => {
      return element.is_parent;
    })
    setFacilityDetails( filteredOverviewArr);
  }

  useEffect(() => {
    const fetchFacility = async () => {
      try {
        setIsLoading(true);
        const userDetail = await getData<any[]>(`${endpoints.getUserById}/${id}`);
        const userDetails = userDetail.data[0];
        const isVerified = (userDetails.hpr_id || userDetails.abha_id) ? 'true' : 'false';
        dispatch(updateForm("isVerified",isVerified ));
        if(userDetails?.usertype_name==='Facility Level User'){
          setIsFacilityOrFieldUser('Facility Level User');
          fetchLinkedFacilitiesInfo();
        }
        else if(userDetails?.usertype_name==='Field Level User'){
          setIsFacilityOrFieldUser('Field Level User');
          fetchLinkedFacilitiesInfo();
        }
        else{
          setIsFacilityOrFieldUser('');
        }
        setStatusActive(userDetails.user_status)
        let isGrampanchayat:boolean=false;
        if(userDetails?.state_code){
        try{
          isGrampanchayat=await isUsingGramPanchayatUtils(userDetails?.state_code);
        }
          catch(error:any){
             errorLogger(error?.response?.data||error?.response||error)
          }
      }
      if(isGrampanchayat){
        setRoleFormData((role_details: any) => ({
          ...role_details,
          village: {
            ...role_details.village,
            '#isVisible' : false,
          },
          gram_panchayat: {
            ...role_details.gram_panchayat,
            '#isVisible' : true,
          }
        }));
      }
      else{
        setRoleFormData((role_details: any) => ({
          ...role_details,
          village: {
            ...role_details.village,
            '#isVisible' : true,
          },
          gram_panchayat: {
            ...role_details.gram_panchayat,
            '#isVisible' : false,
          }
        }));
      }
        if(userDetails?.urban_rural_name?.toLowerCase() === 'rural' && userDetails?.block_id && (userDetails?.usertype_name==="Field Level User"||userDetails?.usertype_name==="Facility Level User" )){
          try {
            if(isGrampanchayat){
              const gramPanchayat = await getDataWithCache<any>(`${endpoints.getGramPanchayatByBlockId(userDetails.block_id)}`);
              const gramPanchayatOptions = gramPanchayat?.data.map((option1: any) => ({
                value: `${option1.gram_panchayat_name}-${option1.gram_panchayat_code}`,
                label: `${option1.gram_panchayat_name}-${option1.gram_panchayat_code}`,
                id: option1.gram_panchayat_id,
                code:option1.gram_panchayat_code
              }));
              setRoleFormData((role_details:any) => ({
                ...role_details,
                gram_panchayat: {
                  ...role_details.gram_panchayat,
                  '#options': gramPanchayatOptions,
                  '#required': gramPanchayatOptions?.length  ? true : false,
                  '#isDisabled' : false,
                },
              }))
            }
            else{
              const postData = {
                        p_state_id: userDetails.state_id,
                        p_dist_id: userDetails.district_id,
                        p_sub_dist_ids: userDetails?.sub_district_id ? [userDetails.sub_district_id] : [],
                        p_block_ids: [userDetails.block_id],
                        p_hbsd_ids: [],
                      }
              const getAllVillagesInBlock = await axios.post(`${endpoints.getVillagesByStateDistSubDisBlockId}`, postData, Auth.loggedInWithJSON());
              //const getAllVillagesInBlock = await getData<any[]>(`${endpoints.getVillageByBlockId(userDetails.block_id)}`);
              const getVillage_options = getAllVillagesInBlock.data?.data?.map((key: any) => ({
                value: `${key.village_name} - ${key.village_code}`,
                label: `${key.village_name} - ${key.village_code}`,
                id: key.village_id,
                code: key.village_code,
              }));
              setRoleFormData((role_details: any) => ({
                ...role_details,
                village: {
                  ...role_details.village,
                  '#options' : getVillage_options,
                  '#isDisabled' : false,
                },
              }));
            }
          } catch (error) {
            setIsLoading(false);
           return; 
          }
        }
        if(userDetails?.urban_rural_name?.toLowerCase() === 'urban' && userDetails?.ulb_id){
          try {
          const getAllWardsInUlb = await getData<any[]>(`${endpoints.getWard(userDetails.ulb_id)}`);
          const getWard_options = getAllWardsInUlb.data.map((key: any) => ({
            value: `${key.ward_name} - ${key.ward_code}`,
            label: `${key.ward_name} - ${key.ward_code}`,
            id: key.ward_id,
            code: key.ward_code,
          }));
          setRoleFormData((role_details: any) => ({
            ...role_details,
            ward: {
              ...role_details.ward,
              '#options' : getWard_options,
              '#isDisabled' : false,
            },
          }));
          } catch (error) {
            setIsLoading(false);
           return; 
          }
        }
        let lengthHprAbha=false;
        if(userDetails.abha_id){
          if(userDetails.abha_id.length===14){
            lengthHprAbha=true;
          }
        }
        else if(userDetails.hpr_id){
          if(userDetails.hpr_id.length===14){
            lengthHprAbha=true;

          }
        }
        if(userDetails.user_status==='Inactive'){
          if((userDetails.usertype_name==='Field Level User'  && !lengthHprAbha) || (userDetails.usertype_name==='Facility Level User'  && !lengthHprAbha)){
            if(userDetails.user_designation_name!=='Hospital Adminstrator - DH and SDH' && userDetails.user_designation_name!=='Hospital Administrator - Other Central government hospitals' &&
              userDetails.user_designation_name!=='Medical Director' && userDetails.user_designation_name!=='Medical Supritendent'
            )
            {
              setIsStatusActive(true);
              setUserFormData((userFormState: any) => ({
                ...userFormState,
                fName: {
                  ...userFormState.fName,
                  '#isDisabled': false,
                },
                lName: {
                  ...userFormState.lName,
                  '#isDisabled': false,
                },
                hpr_id: {
                  ...userFormState.hpr_id,
                  '#isDisabled': false,
                },
                user_status: {
                  ...userFormState.user_status,
                  '#isDisabled': true,
                },
                effective_from_date:{
                  ...userFormData.effective_from_date,
                  '#required': false,
                  '#isDisabled':true, 
                  },
              })) 
              
                setuserFormState({
                  ...userFormState,
                  effective_from_date:{
                    ...userFormState.effective_from_date,
                   //value:'', 
                   isDisable:true
                    },
                });
            }
            else{
              setUserFormData((userFormState: any) => ({
                ...userFormState,
                hpr_id: {
                  ...userFormState.hpr_id,
                  '#isDisabled': true,
                },
                fName: {
                  ...userFormState.fName,
                  '#isDisabled': true,
                },
                lName: {
                  ...userFormState.lName,
                  '#isDisabled': true,
                },
                user_status: {                          
                  ...userFormState.user_status,
                    '#isDisabled': false,
                  },
              })); 
            }
          }
          else{
            setUserFormData((userFormState: any) => ({
              ...userFormState,
              fName: {
                ...userFormState.fName,
                '#isDisabled': true,
              },
              lName: {
                ...userFormState.lName,
                '#isDisabled': true,
              },
              hpr_id: {
                ...userFormState.hpr_id,
                '#isDisabled': true,
              },
              user_status: {                          
                ...userFormState.user_status,
                  '#isDisabled': false,
                },
            })); 
          }
        }
        setEffectiveDate(userDetails.effective_from_dt ? dayjs(userDetails.effective_from_dt) : undefined);
        setStatusValue(userDetails.user_status==='Active'?true:false);
        setuserFormState((userFormState: any) => ({
          ...userFormState,
          fName: {
            ...userFormState.fName,
            value: userDetails.first_name,
          },
          lName: {
            ...userFormState.lName,
            value: userDetails.last_name,
          },
          user_type: {
            ...userFormState.user_type,
            value: userDetails.usertype_name,
            id: userDetails.usertype_id,
            code: userDetails.usertype_code,
          },
          designation: {
            ...userFormState.designation,
            value: userDetails.user_designation_name,
            id: userDetails.user_designation_id,
            code: userDetails.user_designation_code,
          },
          mob: {
            ...userFormState.mob,
            value: userDetails.mob,
          },
          a_mob: {
            ...userFormState.a_mob,
            value: userDetails.alternate_mob,
          },
          email: {
            ...userFormState.email,
            value: userDetails.email,
          },
          doj: {
            ...userFormState.doj,
            value: dayjs(userDetails.doj),
          },
          effective_from_date: {
            ...userFormState.effective_from_date,
            value: userDetails.effective_from_dt ? dayjs(userDetails.effective_from_dt) : undefined,
          },
          user_status: {
            ...userFormState.user_status,
            value: userDetails.user_status==='Active'?true:false,
          },
         
        }));
        setOldMobileNumber(userDetails.mob);
        setOldEmail(userDetails.email);
        setUpdateFormData({
          ...updateFormData,
          userDetails:{
            ...updateFormData.userDetails,
            original:{
              ...updateFormData.userDetails.original,
              fName: userDetails.first_name,
              lName: userDetails.last_name,
              email: userDetails.email,
              mob: userDetails.mob,
              a_mob: userDetails.alternate_mob,
              hpr_id:userDetails.hpr_id,
              user_status:userDetails.user_status,
              reportUserWithLineListingData:userDetails?.report_user_with_line_listing_data,
              volunteerForPmsma:userDetails?.volunteer_for_pmsma,
              offlineModeAccess:userDetails?.offline_mode_access,
              mfa:userDetails?.mfa,
              },
              updated:{
                ...updateFormData.userDetails.updated,
                fName: userDetails.first_name,
                lName: userDetails.last_name,
                email: userDetails.email,
                mob: userDetails.mob,
                a_mob: userDetails.alternate_mob,
                hpr_id:userDetails.hpr_id,
                user_status:userDetails.user_status,
                reportUserWithLineListingData:userDetails?.report_user_with_line_listing_data,
                volunteerForPmsma:userDetails?.volunteer_for_pmsma,
                offlineModeAccess:userDetails?.offline_mode_access,
                mfa:userDetails?.mfa,
                },
            },
          }
        );
          dispatch(updateForm("fName",userDetails.first_name));
          dispatch(updateForm("lName",userDetails.last_name));
        const roles = await getData<any[]>(`${endpoints.getRoleByUserId(id)}`)
        const rolesValue = roles.data && roles.data.map((value: any) => value.role_name);
        const rolesCode = roles.data && roles.data.map((value: any) => value.role_code);
        const rolesId = roles.data && roles.data.map((value: any) => value.role_id);
        const compositeId = roles.data && roles.data.map((value: any) => value.composite_role_id);
        const rolesOptions = roles.data.map((key: any) => ({
          value: key.role_name,
          label: key.role_name,
          id: key.role_id,
          compositeId:key.composite_role_id
        }));
        setPreviousRoles(rolesOptions);
        setCurrentRoles(rolesId);
        setCurrentCompositeRoles(compositeId);
        const rolesByTypeId = await getDataWithCache<any[]>(`${endpoints.getAllRoles(userDetails.usertype_id,userDetails.user_designation_id)}`)

        const rolesByTypeIdOptions = rolesByTypeId.data.map((key: any) => ({
          value: key.role_name,
          label: key.role_name,
          id: key.role_id,
          compositeId:key.composite_role_id
        }));
        setRoleFormData((role_details: any) => ({
          ...role_details,
          role_name: {
            ...role_details.role_name,
            '#options': rolesByTypeIdOptions,
          },
        }))
        setRoleFormState((roleFormState: any) => ({
          ...roleFormState,
          role_name: {
            ...roleFormState.role_name,
            value: rolesValue,
            id: rolesId,
            code: rolesCode,
            compositeId:compositeId,
          },
        }));
        setUpdateFormData({
          ...updateFormData,
          roleLocationDetails:{
            ...updateFormData.roleLocationDetails,
            original:{
              ...updateFormData.roleLocationDetails.original,
              role_name: rolesValue,
              
              },
              updated:{
                ...updateFormData.roleLocationDetails.updated,
                role_name: rolesValue,
                },
            },
          });

        if (userDetails.usertype_name === "Facility Level User") {
          dispatch(updateForm('userType','Facility Level User'))

          if (userDetails.user_designation_name === 'MPW/MPHW') { 
            dispatch(updateForm('designation','MPW/MPHW'));
            setUserFormData((userFormState: any) => ({
              ...userFormState,
              hpr_id: {
                ...userFormState.hpr_id,
                '#isDisabled': true,
                '#title': 'ABHA Number',
                '#webform_key': 'abha_id',
              }
            }))
            setuserFormState((userFormState: any) => ({
              ...userFormState,
              abha_id: {
                ...userFormState.abha_id,
                value: userDetails.abha_id,
              }
            }))
            dispatch(updateForm("hfrAbha", userDetails.abha_id));
            if (userDetails.abha_id) {
              if (userDetails.abha_id.length === 14) {
                setIsVerified(true);
                setIsHprAbhaVerified(true);
                setUserFormData((userFormState: any) => ({
                  ...userFormState,
                  hpr_id: {
                    ...userFormState.hpr_id,
                    '#isDisabled': true,
                    '#title': 'ABHA Number',
                    '#webform_key': 'abha_id',
                  }
                }))
              }
            }
          } 
          else if(userDetails.user_designation_name!=='Hospital Adminstrator - DH and SDH' && userDetails.user_designation_name!=='Hospital Administrator - Other Central government hospitals' &&
            userDetails.user_designation_name!=='Medical Director' && userDetails.user_designation_name!=='Medical Supritendent'
          ){
            setUserFormData((userFormState: any) => ({
              ...userFormState,
              hpr_id: {
                ...userFormState.hpr_id,
                '#isDisabled': false,
                '#title': 'HPR ID',
                '#webform_key': 'hpr_id',
              }
            }))
          }
          else{
            setUserFormData((userFormState: any) => ({
              ...userFormState,
              hpr_id: {
                ...userFormState.hpr_id,
                '#isDisabled': true,
                '#title': 'HPR ID',
                '#webform_key': 'hpr_id',
              }
            }))
          }
          
          
          setuserFormState((userFormState: any) => ({
            ...userFormState,
            hpr_id: {
              ...userFormState.hpr_id,
              value: userDetails.hpr_id,
            }
          }))
          dispatch(updateForm("hfrAbha",userDetails.hpr_id));

          setFormStateForFacility((userFormState: any) => ({
            ...userFormState,
            mobiliser_tagged: {
              ...userFormState.mobiliser_tagged,
              value: "NA",
            },
          }))
          if(userDetails.hpr_id){
            if(userDetails.hpr_id.length===14){
              setIsVerified(true);
              setIsHprAbhaVerified(true);
              const title =  userDetails.user_designation_name !== 'MPW/MPHW' ? 'HPR ID' : 'ABHA Number';
              setUserFormData((userFormState: any) => ({
                ...userFormState,
                hpr_id: {
                  ...userFormState.hpr_id,
                  '#isDisabled': true,
                  '#title': title,
                  '#webform_key': 'hpr_id',

                }
              }))
            }
          }
        }
        else if (userDetails.usertype_name === "Field Level User") {
          // try{
          //   const healthProvider = await getData<any[]>(`${endpoints.getHealthProvTagByUserId}/${id}`)
          //   const fistName = healthProvider.data && healthProvider.data.map((value: any) => value.first_name);
          //   const lastName = healthProvider.data && healthProvider.data.map((value: any) => value.last_name);
          //   const healthProviderCode = healthProvider.data && healthProvider.data.map((value: any) => value.health_provider_code);
          //   const healthProviderId = healthProvider.data && healthProvider.data.map((value: any) => value.health_provider_id);
          //   const name = fistName.join(", ");
          //   setFormStateForFacility((userFormState: any) => ({
          //     ...userFormState,
          //     health_provider_tagged: {
          //       ...userFormState.health_provider_tagged,
          //       value: name,
          //       id: healthProviderId,
          //       code: healthProviderCode,
          //     },
          //   }))
          // }
          // catch(error){
       
          // }
          
          dispatch(updateForm('userType','Field Level User'))
          dispatch(updateForm('designation', userDetails.user_designation_name));
          if(userDetails.abha_id){
            if(userDetails.abha_id.length===14){
              setIsVerified(true);
              setIsHprAbhaVerified(true);
              
            }
          }
          setuserFormState((userFormState: any) => ({
            ...userFormState,
            abha_id: {
              ...userFormState.abha_id,
              value: userDetails.abha_id,
            }
          }))
          dispatch(updateForm("hfrAbha",userDetails.abha_id));
          
          setUserFormData((userFormState: any) => ({
            ...userFormState,
            hpr_id: {
              ...userFormState.hpr_id,
              '#isDisabled': true,
              '#title': 'ABHA Number',
              '#webform_key': 'abha_id',

            }
          }))
        }
        setRoleFormState((roleFormState: any) => ({
          ...roleFormState,
          state: {
            ...roleFormState.state,
            value: userDetails.state_name ? `${userDetails.state_name}-${userDetails.state_code}` : '',
            id: userDetails.state_id,
            code: userDetails.state_code
          },
          district: {
            ...roleFormState.district,
            value: userDetails.district_name ? `${userDetails.district_name}-${userDetails.district_code}` : '',
            id: userDetails.district_id,
            code: userDetails.district_code
          },
          sub_district: {
            ...roleFormState.sub_district,
            value: userDetails.sub_district_name ? `${userDetails.sub_district_name}-${userDetails.sub_district_code}` : '',
            id: userDetails.sub_district_id,
            code: userDetails.sub_district_code
          },
          sub_division: {
            ...roleFormState.sub_division,
            value: userDetails.sub_division ? `${userDetails.sub_division}-${userDetails.sub_division_code}` : '',
            id: userDetails.sub_division_id,
            code: userDetails.sub_division_code
          },
          health_block: {
            ...roleFormState.health_block,
            value: userDetails.health_block ? `${userDetails.health_block}-${userDetails.health_block_code}` : '',
            id: userDetails.health_block_id,
            code: userDetails.health_block_code
          },
          rural_urban: {
            ...roleFormState.rural_urban,
            value: userDetails.urban_rural_name?userDetails.urban_rural_name === 'rural' ? 'Rural' : 'Urban':'',
            id: userDetails.urban_rual_id,
          }
        }))
        setMFAValue(userDetails.mfa);
        setCheckBoxes((roleFormState: any) => ({
          ...roleFormState,
          reportUserWithLineListingData: {
            ...roleFormState.reportUserWithLineListingData,
            value: userDetails.report_user_with_line_listing_data,
          },
          offlineModeAccess: {
            ...roleFormState.offlineModeAccess,
            value: userDetails.offline_mode_access,
          },
          mfa: {
            ...roleFormState.mfa,
            value: userDetails.mfa,
          },
          volunteerForPmsma: {
            ...roleFormState.volunteerForPmsma,
            value: userDetails.volunteer_for_pmsma,
          },

        }))
        if (userDetails.urban_rural_name === 'rural') {
          setRoleFormState((roleFormState: any) => ({
            ...roleFormState,
            block: {
              ...roleFormState.block,
              value: userDetails.block_name ? `${userDetails.block_name}-${userDetails.block_code}` : '',
              id: userDetails.block_id,
              code: userDetails.block_code
            },
            village: {
              ...roleFormState.village,
              value: userDetails.village_name ? `${userDetails.village_name} - ${userDetails.village_code}` : '',
              id: userDetails.village_id,
              code: userDetails.village_code
            },
            gram_panchayat: {
              ...roleFormState.gram_panchayat,
              value: userDetails?.gram_panchayat_name ? `${userDetails?.gram_panchayat_name}-${userDetails?.gram_panchayat_code}` : '',
              id:  userDetails?.gram_panchayat_id?userDetails?.gram_panchayat_id:'' ,
              code:  userDetails?.gram_panchayat_code?userDetails?.gram_panchayat_code:''
            },
          }))
        }
        else {
          setRoleFormState((roleFormState: any) => ({
            ...roleFormState,
            ulb: {
              ...roleFormState.ulb,
              value: userDetails.ulb_name ? `${userDetails.ulb_name}-${userDetails.ulb_code}` : '',
              id: userDetails.ulb_id,
              code: userDetails.ulb_code
            },
            ward: {
              ...roleFormState.ward,
              value: userDetails.ward_name ? `${userDetails.ward_name} - ${userDetails.ward_code}` : '',
              id: userDetails.ward_id,
              code: userDetails.ward_code
            },
          }))
        }
        //setting facility details
        setFormStateForFacility((userFormState: any) => ({
          ...userFormState,
          health_facility_type: {
            ...userFormState.health_facility_type,
            value: userDetails.facility_type_name,
            id: userDetails.facility_type_id
          },
          health_fName: {
            ...userFormState.health_fName,
            value: userDetails.facility_name,
            id: userDetails.facility_id,
            code: userDetails.facility_code
          },
          volunteerForPmsma: {
            ...userFormState.volunteerForPmsma,
            value: userDetails.volunteer_for_pmsma,
          }
        }))
        if(userDetails.usertype_name==='Zone / Circle / Region / Division Level User'){
          setRoleFormState((roleFormState: any) => ({
            ...roleFormState,
            zone_division: {
              ...roleFormState.zone_division,
              value: userDetails.zone_div_circle_name ,
              id: userDetails.zone_div_circle_id,
              code: userDetails.zone_div_circle_code
            },
          }))
          setRoleFormData((role_details: any) => ({
            ...role_details,
            zone_division: {
              ...role_details.zone_division,
              '#multiDropdown':true,
            },
          }));
        }
        else{
          setRoleFormState((roleFormState: any) => ({
            ...roleFormState,
            zone_division: {
              ...roleFormState.zone_division,
              value: userDetails.zone_div_circle_name? userDetails.zone_div_circle_name[0]:'',
              id:userDetails.zone_div_circle_name? userDetails.zone_div_circle_id[0]:'',
              code:userDetails.zone_div_circle_name? userDetails.zone_div_circle_code[0]:''
            },
          }))
          setRoleFormData((role_details: any) => ({
            ...role_details,
            zone_division: {
              ...role_details.zone_division,
              '#multiDropdown':false,
            },
          }));
        }
        userDetails.state_id && getZoneDiVCircleByStateID(userDetails.state_id);

        if(userDetails?.usertype_name === "Field Level User" || userDetails?.usertype_name === "Facility Level User"){
          if(userDetails.user_designation_name === "Community Health Officer - CHO" || userDetails.user_designation_name === "ANM" || userDetails.user_designation_name === "ASHA")
            {
              if(userDetails?.user_status === 'Inactive'){
                setCheckBoxesFormData((role_details:any) => ({
                  ...role_details,
                  offlineModeAccess:{
                    ...role_details?.offlineModeAccess,
                    '#isVisible':'isVisible',
                    '#isDisabled':true,
                  }
                })); 
              }
              if(userDetails?.user_status === 'Active'){
                setCheckBoxesFormData((role_details:any) => ({
                  ...role_details,
                  offlineModeAccess:{
                    ...role_details?.offlineModeAccess,
                    '#isVisible':'isVisible',
                    '#isDisabled':false,
                  }
                })); 
              }
            }
          else{
            setCheckBoxesFormData((role_details:any) => ({
              ...role_details,
              offlineModeAccess:{
                ...role_details?.offlineModeAccess,
                '#isVisible':'isNotVisible',
                '#isDisabled':true,
              }
            })); 
          }

        }
        else if(userDetails?.usertype_name !== "Field Level User" || userDetails?.usertype_name !== "Facility Level User"){
          if(userDetails?.user_status === 'Inactive'){
            setCheckBoxesFormData((role_details:any) => ({
              ...role_details,
              offlineModeAccess:{
                ...role_details?.offlineModeAccess,
                '#isDisabled':true,
                '#isVisible':'isNotVisible'
              },
              mfa:{
                ...role_details?.mfa,
                '#isDisabled':true,
              },
              reportUserWithLineListingData:{
                ...role_details?.reportUserWithLineListingData,
                '#isDisabled':true,
              },
              volunteerForPmsma:{
                ...role_details?.volunteerForPmsma,
                '#isDisabled':true,
              },
            }));
            setCheckBoxes((roleFormState:any) => ({
              ...roleFormState,
              offlineModeAccess: {
                ...roleFormState.offlineModeAccess,
                value: false,
              },
            }));
          }
          else{
            setCheckBoxesFormData((role_details:any) => ({
              ...role_details,
              offlineModeAccess:{
                ...role_details?.offlineModeAccess,
                '#isDisabled':true,
                '#isVisible':'isNotVisible',
              },
              mfa:{
                ...role_details?.mfa,
                '#isDisabled':false,
              },
              reportUserWithLineListingData:{
                ...role_details?.reportUserWithLineListingData,
                '#isDisabled':false,
              },
              volunteerForPmsma:{
                ...role_details?.volunteerForPmsma,
                '#isDisabled':false,
              },
            }));
            setCheckBoxes((roleFormState:any) => ({
              ...roleFormState,
              offlineModeAccess: {
                ...roleFormState.offlineModeAccess,
                value: false,
              },
            }));
          }
        }
        if(userDetails.user_status === 'Inactive'){
          setUserFormData((userFormState: any) => (
            setIsFieldDisabled(userFormState, {
              '#required':false,
              '#isDisabled':true,
            },
             'email', 'mob', 'a_mob','designation', 'doj', 'user_type')
          ));
          setRoleFormData((role_details: any) => (
            setIsFieldDisabled(role_details, {
              '#required':false,
              '#isDisabled':true,
            },
             'role_name','state','zone_division','district','rural_urban','ulb','sub_district','block','health_block','sub_division','ward','village')
          ));
          setCheckBoxesFormData((role_details: any) => (
            setIsFieldDisabled(role_details, {
              '#required':false,
              '#isDisabled':true,
            },
             'reportUserWithLineListingData','volunteerForPmsma','mfa','offlineModeAccess')
          ));
        } 
        setIsLoading(false);
      }
      catch(error:any){
        setIsLoading(false);
        errorLogger(error?.response?.data||error?.response||error)
      }
    }
    fetchFacility();

    return () => {
      dispatch(updateForm("userStatusUpdate", ''))
    }
  }, []);
    useEffect(()=>{
      if(clearHpr){
        setuserFormState((formState1: any) => ({
          ...formState1,
          hpr_id:{
            ...formState1.hpr_id,
            value:''
          }
        }));
        dispatch(updateForm("hprNumberCheck",false));
        dispatch(updateForm("ishprEntered",false));
        dispatch(updateForm("isOkButtonClicked",true))
      }
    },[clearHpr])
  useEffect(()=>{
    
    
      if(isVerify==='true'){
        if(userFormState.user_type.value==='Facility Level User' && userFormState.designation?.value !== 'MPW/MPHW'){
          setIsStatusActive(false);
          setIsHprAbhaVerified(true);
          setuserFormState((UserDetailsFormStateError: any) => ({
            ...UserDetailsFormStateError,
            hpr_id:{
              ...UserDetailsFormStateError.hpr_id,
              value:hfrAbhaId
            },
            user_status:{
              ...UserDetailsFormStateError.user_status,
             value:true, 
            }, 
          }));
          setUserFormData((userFormState: any) => ({
            ...userFormState,
            user_status: {
              ...userFormState.user_status,
              '#isDisabled': false,
            },
            hpr_id: {
              ...userFormState.hpr_id,
              '#isDisabled': true,
            },
            fName: {
              ...userFormState.fName,
              '#isDisabled':true,
            },
            lName: {
              ...userFormState.lName,
              '#isDisabled':true,
            }
          })) 
        }
        else if(userFormState.user_type.value==='Field Level User' || (userFormState.user_type.value==='Facility Level User' && userFormState.designation?.value === 'MPW/MPHW')){
          setIsStatusActive(false);
          setIsHprAbhaVerified(true);
          setuserFormState((UserDetailsFormStateError: any) => ({
            ...UserDetailsFormStateError,
            abha_id:{
              ...UserDetailsFormStateError.abha_id,
              value:hfrAbhaId
            },
            user_status:{
              ...UserDetailsFormStateError.user_status,
             value:true, 
              },
          }));
          setUserFormData((userFormState: any) => ({
            ...userFormState,
            user_status: {
              ...userFormState.user_status,
              '#isDisabled': false,
            },
          })) 
        }
       
      }
      else{
       if(userFormState.user_type.value==='Facility Level User' && userFormState.designation?.value !== 'MPW/MPHW'){
        setIsStatusActive(true);
        setIsHprAbhaVerified(false);
        setuserFormState((UserDetailsFormStateError: any) => ({
          ...UserDetailsFormStateError,
          user_status:{
            ...UserDetailsFormStateError.user_status,
            value:false
          },
          hpr_id:{
            ...UserDetailsFormStateError.hpr_id,
            value:hfrAbhaId
          }
         
        }));
        setUserFormData((userFormState: any) => ({
          ...userFormState,
          user_status: {
            ...userFormState.user_status,
            '#isDisabled': true,
          },
        })) 

       }
       else if(userFormState.user_type.value==='Field Level User' || (userFormState.user_type.value==='Facility Level User' && userFormState.designation?.value === 'MPW/MPHW')){
        setIsStatusActive(true);
        setIsHprAbhaVerified(false);
        setuserFormState((UserDetailsFormStateError: any) => ({
          ...UserDetailsFormStateError,
          user_status:{
            ...UserDetailsFormStateError.user_status,
            value:false
          },
          hpr_id:{
            ...UserDetailsFormStateError.hpr_id,
            value:hfrAbhaId
          }
         
        }));
        setUserFormData((userFormState: any) => ({
          ...userFormState,
          user_status: {
            ...userFormState.user_status,
            '#isDisabled': true,
          },
        })) 
       }
      }
    
  },[isVerify]);
  //enabling and disabling effective from date based on toggle status
  useEffect(()=>{
    if(userFormState.user_status.value!==statusValue){
      setUserFormData({
        ...userFormData,
        effective_from_date:{
          ...userFormData.effective_from_date,
          '#required': true,
          '#isDisabled':false, 
          },
        });
        setuserFormState({
          ...userFormState,
          effective_from_date:{
            ...userFormState.effective_from_date,
           value:'', 
           isDisable:false
            },
        });
    }
    else if(userFormState.user_status.value===statusValue){
      setUserFormData({
        ...userFormData,
        effective_from_date:{
          ...userFormData.effective_from_date,
          '#required': false,
          '#isDisabled':true, 
          },
        });
        setuserFormState({
          ...userFormState,
          effective_from_date:{
            ...userFormState.effective_from_date,
           value:effectiveDate, 
           isDisable:true
            },
        });
    }
    else if(userFormState.user_status.value===true  && isStatusActive===false){
      setUserFormData({
        ...userFormData,
        effective_from_date:{
          ...userFormData.effective_from_date,
          '#required': false,
          '#isDisabled':true, 
          },
        });
        setuserFormState({
          ...userFormState,
          effective_from_date:{
            ...userFormState.effective_from_date,
           //value:'', 
           isDisable:true
            },
        });
    }
    else if(userFormState.user_status.value===false && isStatusActive===false){
      setUserFormData({
        ...userFormData,
        effective_from_date:{
          ...userFormData.effective_from_date,
          '#required': true,
          '#isDisabled':false, 
          },
        });
        setuserFormState({
          ...userFormState,
          effective_from_date:{
            ...userFormState.effective_from_date,
           //value:'', 
           isDisable:false
            },
        });
    }
  },[userFormState.user_status.value])
  useEffect(()=>{
    if(checkBoxes.offlineModeAccess.value===true){
    setCheckBoxesFormData((role_details:any) => ({
      ...role_details,
      mfa:{
        ...role_details?.mfa,
        '#isDisabled':true,
       
      },
    }));
    setCheckBoxes((roleFormState:any) => ({
      ...roleFormState,
      mfa: {
        ...roleFormState.mfa,
        value: false,
        
      },
    }));
  }
  else{
    setCheckBoxesFormData((role_details:any) => ({
      ...role_details,
      mfa:{
        ...role_details?.mfa,
        '#isDisabled':false,
      },
    }));
    setCheckBoxes((roleFormState:any) => ({
      ...roleFormState,
      mfa: {
        ...roleFormState.mfa,
        value: MFAValue,
      },
    }));
  }
  },[checkBoxes.offlineModeAccess.value])
  //changing zone div circle based on state change
  useEffect(()=>{
    
    roleFormState.state.id && getZoneDiVCircleByStateID(roleFormState.state.id);
   
  },[roleFormState.state.id])
    const handleOK=async()=>{
      dispatch(updateForm("isNotVerified",false));
      if(hprNullCheck){
          dispatch(updateForm("isOkButtonClicked",true))
      }
      if(hprNumberCheck){
          dispatch(updateForm("ishprEntered",true));
          dispatch(updateForm("clearHpr",true));
          
      }
      setAlertModalOpen(false)
    }
  //Zone Division Circle function
  const getZoneDiVCircleByStateID=async (stateId:any)=>{
    try{
      const zonesDivCircle = await getData<any[]>(`${endpoints.getZoneDiVCircleByStateID}/${stateId}`)
      const zonesDivCircleOptions = zonesDivCircle.data.map((key: any) => ({
        value: key.zone_div_circle_name,
        label: key.zone_div_circle_name,
        id: key.zone_div_circle_id,
        code:key.zone_div_circle_code
      }));
      setRoleFormData((role_details: any) => ({
        ...role_details,
        zone_division: {
          ...role_details.zone_division,
          '#options' : zonesDivCircleOptions,
        },
      }));
    }
    catch(error:any){
       errorLogger(error?.response?.data||error?.response||error)
    }
  }
  //Error handling
  const isError: boolean[] = [];
  //Saving the data and error handling
  const hfrAbhaId=useSelector((state:RootState)=>state.user.hfrAbha);
  const checkEmailAlreadyExists=async (emailId:string)=>{
    try{
      const payload={
        "emailId":emailId
      }
      const encodedPayload = encodeWithKeyAndShift(JSON.stringify(payload));
      const response = await postDataJSON<any>(`${endpoints.checkEmailAlreadyExists}`, {data:encodedPayload});
      const decodedData =  await JSON.parse(decodeWithKeyAndShift(response?.data?.data));
      return decodedData[0]?.check_email_exists
  }
  catch(error:any){
    return false;
  }
  }
  const checkUserHasSessions = async (mobileNumber: string) => {
    try {
      const data = {
        "userName": mobileNumber,
      }
      const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
      const response = await postDataJSON<any>(`${endpoints.getUserSessions}`, { data: encodedPayload });
      const decodedResponse = JSON.parse(decodeWithKeyAndShift(response?.data?.data));
      const sessions = decodedResponse?.data;
      return sessions?.length > 0;

    }
    catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error)
      toast.error("Error while checking user sessions", { position: "top-center" })
      return true;
    }
  }
  const onHandleSave = async () => {
    //debugger;
    {//User Form State Errror Handling
      const UserDetailsFormStateError = {
        ...userFormState
      };
      let isUserFormError = false;
      let emailExist=false;
      if (UserDetailsFormStateError.email.value.trim() && /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(UserDetailsFormStateError.email.value) && UserDetailsFormStateError.email.value.trim()!==oldEmail) {
        emailExist= await checkEmailAlreadyExists(UserDetailsFormStateError.email.value.trim())
      }
      Object.keys(UserDetailsFormStateError).map((item) => {
        if (item === 'fName') {
          if (!UserDetailsFormStateError.fName.value.trim()) {
            isUserFormError = true;
            UserDetailsFormStateError.fName.isError = true;
            //UserDetailsFormStateError.fName.message = t('userManagementErrors.firstNameBlank');
            UserDetailsFormStateError.fName.message = 'First name cannot be kept blank. Enter a valid first name.';

          }
          else if (!/^[A-Za-z]+(?:[.\s]+[A-Za-z]+)*\.?$/.test(UserDetailsFormStateError.fName.value)) {
            isUserFormError = true;
            UserDetailsFormStateError.fName.isError = true;
           // UserDetailsFormStateError.fName.message = t('userManagementErrors.firstNameSpecialChar');
            UserDetailsFormStateError.fName.message = 'Entered first name is invalid. Only alphabets,spaces and dot(.) are allowed.';
          }
          else if (UserDetailsFormStateError.fName.value.length > 100) {
            isUserFormError = true;
            UserDetailsFormStateError.fName.isError = true;
            //UserDetailsFormStateError.fName.message = t('userManagementErrors.firstNameLength');
            UserDetailsFormStateError.fName.message = 'Entered first name length is invalid. Max 100 characters are allowed.';
          }
          else {
            UserDetailsFormStateError.fName.isError = false;
          }
        }
        
        else if (item === 'lName') {
          if (!UserDetailsFormStateError.lName.value.trim()) {
            isUserFormError = true;
            UserDetailsFormStateError.lName.isError = true;
            //UserDetailsFormStateError.lName.message =t('userManagementErrors.lasNameBlank');
            UserDetailsFormStateError.lName.message ='Last name cannot be kept blank. Enter a valid last name.';
          }
          else if (!/^[a-zA-Z\s]+$/.test(UserDetailsFormStateError.lName.value)) {
            isUserFormError = true;
            UserDetailsFormStateError.lName.isError = true;
            //UserDetailsFormStateError.lName.message =  t('userManagementErrors.lastNameSpecialChar');
            UserDetailsFormStateError.lName.message = 'Entered last name is invalid. Number & Special characters are not allowed.';
          }
          else if (UserDetailsFormStateError.lName.value.length > 100) {
            isUserFormError = true;
            UserDetailsFormStateError.lName.isError = true;
           // UserDetailsFormStateError.lName.message = t('userManagementErrors.lastNameLength');
            UserDetailsFormStateError.lName.message ='Entered last name length is invalid. Max 100 characters are allowed.';
          }
          else {
            UserDetailsFormStateError.lName.isError = false;
          }
        }
        else if (item === 'mob') {
          if (!UserDetailsFormStateError.mob.value.length) {
            isUserFormError = true;
            UserDetailsFormStateError.mob.isError = true;
            UserDetailsFormStateError.mob.message = 'Phone number cannot be left blank. Please enter a valid phone number.';
          }
          else if (UserDetailsFormStateError.mob.value.length!== 10 ) {
            isUserFormError = true;
            UserDetailsFormStateError.mob.isError = true;
            UserDetailsFormStateError.mob.message = 'Invalid Entry. Enter 10 digits valid Phone Number.';
          }
          else if (UserDetailsFormStateError.mob.value.startsWith('0') ||
          UserDetailsFormStateError.mob.value.startsWith('+91')) {
            isUserFormError = true;
            UserDetailsFormStateError.mob.isError = true;
            UserDetailsFormStateError.mob.message = 'Invalid Entry. Enter 10 digits valid Phone Number.';
          }
          else {
            UserDetailsFormStateError.mob.isError = false;
          }
        }

        else if (item === 'a_mob') {
          if(UserDetailsFormStateError.a_mob.value){
            if (UserDetailsFormStateError.a_mob.value.length!== 10) {
              UserDetailsFormStateError.a_mob.isError = true;
              UserDetailsFormStateError.a_mob.message = 'Invalid Entry. Enter 10 digits valid Phone Number.';
            }
            else if (UserDetailsFormStateError.a_mob.value.startsWith('0') ||
            UserDetailsFormStateError.a_mob.value.startsWith('+91')) {
              isUserFormError = true;
            UserDetailsFormStateError.a_mob.isError = true;
            UserDetailsFormStateError.a_mob.message = 'Invalid Entry. Enter 10 digits valid Phone Number.';
          }
          else {
            UserDetailsFormStateError.a_mob.isError = false;
          }
        }
      }
        else if (item === 'email') {
          // const regex = /^\S+@\S+\.\S+$/;
           if (UserDetailsFormStateError.email.value && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(UserDetailsFormStateError.email.value)) {
            UserDetailsFormStateError.email.isError = true;
            isUserFormError = true;
            UserDetailsFormStateError.email.message = 'Enter correct Email format to continue.';
           }
           else if (emailExist) {
            UserDetailsFormStateError.email.isError = true;
            isUserFormError = true;
            UserDetailsFormStateError.email.message = 'Email already registered with a different user.';
           }
           else {
            UserDetailsFormStateError.email.isError = false;
           }
         }
        else if (item === 'effective_from_date') {
          const effectiveDateCheck:boolean=userFormData.effective_from_date['#isDisabled'];
          if(!userFormState.effective_from_date.value && !effectiveDateCheck){
           if (!UserDetailsFormStateError.effective_from_date.value) {
            UserDetailsFormStateError.effective_from_date.isError = true;
            isUserFormError = true;
            UserDetailsFormStateError.effective_from_date.message = 'Enter Effective from Date to continue.';
           }
           else {
            UserDetailsFormStateError.effective_from_date.isError = false;
           }
          }
          else{
            UserDetailsFormStateError.effective_from_date.isError = false;
          }
          
         }
        else if (item === 'hpr_id' && UserDetailsFormStateError.hpr_id.value) {
                if ( !/^[0-9]+$/.test(UserDetailsFormStateError.hpr_id.value)) {
                  isUserFormError = true;
                  UserDetailsFormStateError.hpr_id.isError = true;
                  UserDetailsFormStateError.hpr_id.message = 'Entered hpr id is invalid. Alphabets & Special characters are not allowed.';
                  dispatch(updateForm("hprNullCheck",false))
                  dispatch(updateForm("hprNumberCheck",false));
                  dispatch(updateForm("isOkButtonClicked",false))
                  dispatch(updateForm("ishprEntered",false));
                  
                }
                else {
                  UserDetailsFormStateError.hpr_id.isError = false;
                }
              }
            if(isVerify!=='true'){
              if((!isUserFormError && !UserDetailsFormStateError.hpr_id.value && UserDetailsFormStateError.user_type.value==='Facility Level User' && !isOkButtonClicked && !hprNullCheck)){
                setAlertModalOpen(true)
                isUserFormError = true;
                dispatch(updateForm("hprNullCheck",true))
                dispatch(updateForm("hprNumberCheck",false));
                dispatch(updateForm("ishprEntered",false));
              }
              if((!ishprEntered && UserDetailsFormStateError.hpr_id.value && UserDetailsFormStateError.hpr_id.value && /^[0-9]+$/.test(UserDetailsFormStateError.hpr_id.value) && !hprNumberCheck)){
                setAlertModalOpen(true)
                isUserFormError = true;
                dispatch(updateForm("hprNumberCheck",true));
                dispatch(updateForm("hprNullCheck",false))
                dispatch(updateForm("clearHpr",false));
                dispatch(updateForm("isOkButtonClicked",false))
              }
              if( (UserDetailsFormStateError.user_type.value==='Facility Level User' && UserDetailsFormStateError.hpr_id.value && /^[0-9]+$/.test(UserDetailsFormStateError.hpr_id.value) && isNotVerified)){
                setAlertModalOpen(true)
                isUserFormError = true;
              }
            }
        // else if (item === 'hpr_abha_id') {
        //   if (!hfrAbhaId) {
        //     isUserFormError = true;
        //     UserDetailsFormStateError.hpr_abha_id.isError = true;
        //     UserDetailsFormStateError.hpr_abha_id.message = 'Enter the Id to continue.';
        //   }
        //   else {
        //     UserDetailsFormStateError.hpr_abha_id.isError = false;
        //   }
        // }

      })
      setuserFormState(UserDetailsFormStateError);
      isError[0] = isUserFormError;
    }
    {//Role Form State Error Handling
      const RoleDetailsFormStateError = {
        ...roleFormState
      };
      let isRoleFormError = false;
      Object.keys(RoleDetailsFormStateError).map((item) => {
        if (item === 'role_name') {
          
          if (RoleDetailsFormStateError.role_name.id.length <= 0) {
            isRoleFormError = true;
            RoleDetailsFormStateError.role_name.isError = true;
           // RoleDetailsFormStateError.role_name.message =  t('userManagementErrors.roleBlank');
            RoleDetailsFormStateError.role_name.message = 'Role cannot be kept blank. Select user role(s)  from dropdown.';
          }
          else {
            RoleDetailsFormStateError.role_name.isError = false;
          }
        }
        else if (item === 'village') {
          if (!RoleDetailsFormStateError.village.value && roleFormData.village?.['#required'] === true  && roleFormData.village?.['#isVisible'] === true) {
            isRoleFormError = true;
            RoleDetailsFormStateError.village.isError = true;
            RoleDetailsFormStateError.village.message = 'Select Village from the dropdown';
          }
          else {
            RoleDetailsFormStateError.village.isError = false;
          }
        }
        else if (item === 'gram_panchayat') {
          if (!RoleDetailsFormStateError.gram_panchayat.value && roleFormData.gram_panchayat?.['#required'] === true && roleFormData.gram_panchayat?.['#isVisible'] === true) {
            isRoleFormError = true;
            RoleDetailsFormStateError.gram_panchayat.isError = true;
            RoleDetailsFormStateError.gram_panchayat.message = 'Select Gram Panchayat / ADC Village from the dropdown';
          }
          else {
            RoleDetailsFormStateError.gram_panchayat.isError = false;
          }
        }

      })
      setRoleFormState(RoleDetailsFormStateError);
      isError[1] = isRoleFormError;
    }
   // let roleCode: any = roleFormState.role_name.code;
    //roleCode = roleCode.filter((code: null) => code != null);
    const isMobileNumberChanged=(userFormState.mob.value)?.toString()!==(oldMobileNumber)?.toString();
    const currentSessionsExist=isMobileNumberChanged? await checkUserHasSessions(oldMobileNumber.toString()):false;
    if(currentSessionsExist){
      toast.error('User already logged in to JANANI. Please ask user to logout from application.', { position: "top-center",});
      return;
    }
    if (isError[0]===false&&isError[1]===false ) {
      let isAbha=false;
      if(userFormState.user_type.value==='Field Level User'){
        isAbha=true;
      }
      const deselectedRoles = previousRoles.filter((role:any) => !currentRoles.includes(role.id));
      const deselectedRolesID = deselectedRoles.map((roles:any)=> roles.id);
      const deselectedCompositeRoles = previousRoles.filter((role:any) => !currentCompositeRoles?.includes(role.compositeId));
      const deselectedCompositeRolesID = deselectedCompositeRoles.map((roles:any)=> roles?.compositeId);
      let isUsermasterChanged = false;
      let isUserlocationChanged = false;
      const isUserimageChanged = false;
      const UDOriginalValues = updateFormData?.userDetails.original;
      const UDUpdatedValues = updateFormData?.userDetails.updated;
      isUsermasterChanged = Object.keys(UDUpdatedValues).some((field) => UDUpdatedValues[field] !== UDOriginalValues[field]);

      const RLoriginalValues = updateFormData.roleLocationDetails.original;
      const RLupdatedValues = updateFormData.roleLocationDetails.updated;
      isUserlocationChanged = Object.keys(RLupdatedValues).some((field) => {
        if (Array.isArray(RLupdatedValues[field]) && Array.isArray(RLoriginalValues[field])) {
          return RLupdatedValues[field].length !== RLoriginalValues[field].length || RLupdatedValues[field].some((val:any, i:any) => val !== RLoriginalValues[field][i]);
        } else {
          return RLupdatedValues[field] !== RLoriginalValues[field];
        }
      });
      const statusActiveFinal=userFormState.user_status.value ? 'Active' : 'Inactive';
      const consentNeededForABha=isAbha? (isHprAbhaVerified?hfrAbhaId:''):'';
      const consentNeededForHPR=isAbha?'': (isHprAbhaVerified?hfrAbhaId:'');
      const consentNeeded=consentNeededForABha?true:consentNeededForHPR?true:false;
      const updatedEmail = userFormState.email.value.trim()?.includes(`rch2.0_${oldMobileNumber}@gmail.com`) ? userFormState.email.value.trim().replace(oldMobileNumber, userFormState.mob.value.trim()) : userFormState.email.value.trim();
      const data = {
        userId:id,
        fName: userFormState.fName.value,
        lName: userFormState.lName.value,
        email: updatedEmail,
        mob: userFormState.mob.value,
        oldMobileNumber:oldMobileNumber,
        userDesignationId: userFormState.designation.id,
        doj: userFormState.doj.value ? dayjs(userFormState.doj.value).format('YYYY-MM-DD') : null,
        userTypeId: userFormState.user_type.id,
        mfa: checkBoxes.mfa.value,
        volunteerForPmsma: checkBoxes.volunteerForPmsma.value,
        userStatus: userFormState.user_status.value ? 'Active' : 'Inactive',
        reportUserWithLineListingData: checkBoxes.reportUserWithLineListingData.value,
        offlineModeAccess: checkBoxes.offlineModeAccess.value,
        stId: roleFormState.state.id,
        deletedZoneDivCircleId: deselectedCompositeRolesID,
        insertedZoneDivCircleId:userFormState.user_type.value==='Zone / Circle / Region / Division Level User'?roleFormState.zone_division.id:[roleFormState.zone_division.id],
        deletedCompositeRoleIds: deselectedCompositeRolesID || [],
        insertedCompositeRoleIds:roleFormState.role_name.compositeId,
        stCode:  roleFormState.state.code,
        deletedRoleIds:deselectedRolesID || [],
        insertedRoleIds: roleFormState.role_name.id,
        effectiveFromDt:userFormState.effective_from_date.value? dayjs(userFormState.effective_from_date.value).format('YYYY-MM-DD') :null,
        mName: user.middle_name,
        alternateMob: userFormState.a_mob.value,
        abhaId:isAbha?( isHprAbhaVerified?hfrAbhaId:''):'',
        hprId:isAbha?'': (isHprAbhaVerified?hfrAbhaId:''),
        distId: roleFormState.district.id,
        distCode: roleFormState.district.code,
        subDistId:roleFormState.sub_district.id,
        ulbId: roleFormState.ulb.id,
        blockId: roleFormState.block.id,
        healthBlockId: roleFormState.health_block.id,
        subDivisionId: roleFormState.sub_division.id,
        pcId: '',
        lacId:'',
        wardId: roleFormState.ward.id,
        villageId: roleFormState.village.id,
        facilityId: formStateForFacility.health_fName.id,
        urbanRuralId: roleFormState.rural_urban.id,
        parentUserId: '',
        parentUsertypeId: '',
        parentRoleId:'',
        imageData:'',
        url:'',
        description:'',
        isUsermasterChanged:isUsermasterChanged ? true : consentNeeded,
        isUserlocationChanged:isUserlocationChanged,
        isUserimageChanged:isUserimageChanged,
        gramPanchayatId:roleFormState.gram_panchayat.id,
        consent_template_details:consentNeeded? consentDetails?.length === 0 ? null : consentDetails.map((item:any) => ({"consent_template_id":item.consent_template_id})):null,
        reverificationProcessId: verificationProcessId || '',      }

      
      //const response = await postDataJSON<any[]>(`${endpoints.updateUser}`, data);
      setIsLoading(true)
      try {
        const response = await axios.put(`${endpoints.updateUser(id)}`, data, Auth.loggedInWithJSON());
        if (response) {
          infoLogger(`User has been Updated Successfully with the mobile number: ${userFormState?.mob?.value}, status: ${userFormState?.user_status?.value}, HPR Id: ${data?.hprId}, ABHA Id: ${data?.abhaId}.`,"User Management - Update User");
          navigate(-1);
          dispatch(resetForm());
          toast.success(`${statusActive===statusActiveFinal?"Records have been successfully corrected & saved":(statusActiveFinal==="Active"?"User has been Activated successfully":"User has been Deactivated successfully")} `, {
            position: "top-center"
          });
        }        
      } catch(error:any) {
        const errorResponse=error?.response?.data?.messages?.[0]?.stackTraces||error?.response?.data?.messages?.[0]?.messageDetails||error?.response?.data?.messages||error?.response?.data||error?.response||error;
        toast.error(`Failed to update user: ${errorResponse}`, {
          position: "top-right"
          });
      } finally {
        setIsLoading(false)
      }
  }

}
const isFacilityDetailsVisible =  userFormState.user_type.value === 'Facility Level User' || userFormState.user_type.value === 'Field Level User';
  const onMobileNumberEditIconClick = () => {
    setShowEditMobileNumberModal(true);
  }
  const handleCloseEditMobileNumber = () => {
    setShowEditMobileNumberModal(false);
  }
  const handleSubmitEditMobileNumber = (newMobileNumber: number) => {
    setuserFormState((prevState: any) => ({
      ...prevState,
      mob: {
        ...prevState.mob,
        value: newMobileNumber.toString(),
      },
    }));
     setUpdateFormData({
      ...updateFormData,
      userDetails:{
        ...updateFormData.userDetails,
        updated:{
          ...updateFormData.userDetails.updated,
          ['mob']:newMobileNumber.toString()
        }
      }
    });
    setShowEditMobileNumberModal(false);
  }
return (
  <>
    <Loading isLoading={isLoading} /> 
    <div className="overview_user_update">
      <div className="user_update">

        <BadgesComponent
          className="over-badge"
          badgeName="User Details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="overview-details-update">
          <div className="update_user_details_page">
            <form className="update_container_user_details">
              <CommonFormFields
                formData={userFormData}
                formState={userFormState}
                handleFormChange={handleUserFormState}
                verified={isVerified}
                onInputFieldEditIconClick={onMobileNumberEditIconClick}
              />
            </form>
          </div>
          <hr></hr>
        </div>
      </div>
      <div className="upgrade_enrollment">
        <BadgesComponent
          className="over-badge"
          badgeName="Role and Location Details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="overview-details-update">
          <div className="update_role_details_page">
            <form className="update_container_role_details">
              <CommonFormFields
                formData={roleFormData}
                formState={roleFormState}
                //  handleFormChange={handleRoleFormState}
                handleFormChange={(value: any, key: string, id: any, option: any, code: any,compositeId:any) => {
                  if (key === 'role_name' || (key==='zone_division' && userFormState.user_type.value==='Zone / Circle / Region / Division Level User')) {
                    id = [];
                    option.length > 0 && value.length > 0 && option.forEach((op: any) => {
                      if (value.includes(op.value)) {
                        id.push(op.id);
                      }
                    });
                    code = [];
                    option.length > 0 && value.length > 0 && option.forEach((op: any) => {
                      if (value.includes(op.value)) {
                        code.push(op.code);
                      }
                    });
                    if(key === 'role_name'){
                    compositeId = [];
                    option.length > 0 && value.length > 0 && option.forEach((op: any) => {
                      if (value.includes(op.value)) {
                        compositeId.push(op.compositeId);
                      }
                    });
                  }
                  }

                  handleRoleFormState(value, key, option, id, code,compositeId);
                }}
              />
            </form>
          </div>
        </div>
      </div>
      <hr></hr>
      {
          isFacilityDetailsVisible &&  
            <div className="overview-details-table">
              <BadgesComponent
                className="over-badge"
                badgeName="Parent Facility details"
                variant="primary-1"
                badgeType="case5"
              />
              <div style={{ marginTop: '20px' }}>
                    <DataTable
                      // data={[
                      //   {
                      //     'Health Facility Type': formStateForFacility.health_facility_type.value?formStateForFacility.health_facility_type.value:'NA',
                      //     'Health Facility Name': formStateForFacility.health_fName.value?formStateForFacility.health_fName.value:'NA',
                      //     'Health Provider Tagged': formStateForFacility.health_provider_tagged.value?formStateForFacility.health_provider_tagged.value:'NA',
                      //   },
                      // ]}
                      data ={facilityDetails}
                      itemsPerPage={[10, 20, 30, 40, 50]}
                      pagination={false}
                      searchTerm={''}
                      height={'50px'}
                      columnHeader={[
                        {
                          name: 'Health Facility Type',
                          key: 'facility_type_name',
                          sortable: true,
                        },
                        {
                          name: 'Health Facility Name',
                          key: 'facility_name',
                          sortable: true,
                        },
                        {
                          name: `${isFacilityOrFieldUser === "Facility Level User"?'Asha/ Mobiliser Tagged':'ANM/ Health Provider Tagged'}`,
                          key: `${isFacilityOrFieldUser === "Facility Level User"?'mobiliser_name':'health_provider_name'}`,
                          sortable: true,
                        },
                        
                      ]} gridFor={""} />
              </div>
            </div>
      }
      { isFacilityDetailsVisible && <hr></hr> }
      <div className="upgrade_checkboxes">
        <BadgesComponent
          className="over-badge"
          badgeName="Other details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="overview-checkboxes-update">
          <div className="update_checkboxes_page">
            <form className="update_checkboxes_details">
              <CommonFormFields
                formData={checkBoxesFormData}
                formState={checkBoxes}
                handleFormChange={handleCheckBoxes}
              />
            </form>
          </div>
        </div>
      </div>
    </div>
    {showEditMobileNumberModal &&
      <MobileNumberOTPVerification
        showModal={showEditMobileNumberModal}
        handleClose={handleCloseEditMobileNumber}
        handleSubmit={handleSubmitEditMobileNumber}
        oldMobileNumber={oldMobileNumber}
        showOnlyTextFieldModal={true}
      />}
    <CommonModal
      show={alertModalOpen}
      handleClose={()=>{}}
      conditionalClass="modal_component dynamic_form_field"
      showCustomHeader={true}
      title=""
      size="md"
      footer={
        <>
          <ButtonModal
            onClick={handleOK}
            id="cancel"
            buttonName={'OK'}
            colorType={'secondary'}
          />
        </>
      }
    >
      <div className='hrp-warning-modal'>
        <div className='icon-class'><RedInfoIcon /></div>
        <div className='warning-text'>
          Please note that you are proceeding without verifying {(userFormState.user_type.value === 'Field Level User' || (userFormState.user_type.value === 'Facility Level User' && userFormState.designation?.value === 'MPW/MPHW')) ? 'ABHA ID' : 'HPR ID'}. In that case, saved user will be inactive and {(userFormState.user_type.value === 'Field Level User' || (userFormState.user_type.value === 'Facility Level User' && userFormState.designation?.value === 'MPW/MPHW')) ? 'ABHA ID' : 'HPR ID'} would not be saved.
        </div>
      </div>      
    </CommonModal>
  </>
)

});
UserManagementUpdate.displayName = 'UserManagementUpdate';

export default UserManagementUpdate;